import { Action, createReducer, on } from '@ngrx/store';

import * as flightsActions from '@flight-results/store/actions/flights-results.actions';
import * as packagesActions from '@packages/packages-result/store/actions/packages-result.actions';
import * as busesActions from '@buses/bus-results/store/actions/bus-results.actions';
import * as autosActions from '@autos/auto-results/store/actions/auto.actions';
import * as hotelsActions from '@hotels/hotel-results/store/actions/hotels.actions';
import * as  userHistoryActions from '@user-history/store/actions/user-history.actions';
import { toggleHeaderEditButtonVisibleAction } from '@shared/base-search-bar/store/actions/search-bar.actions';
import * as activitiesActions from '@activities/activities-results/store/actions/activities-results.actions';
import * as globalActions from '@app/store/actions/global.actions';

export const initialState = true;

const featureReducer = createReducer(
  initialState,
  on(toggleHeaderEditButtonVisibleAction, (state, { value }) => value),
  on(
    userHistoryActions.exchangeSearchAction,
    flightsActions.fetchExchangeTokenAction,
    flightsActions.searchFlightsAction,
    flightsActions.fetchAirGroupResultsAction,
    flightsActions.fetchAirResultsBySectorAction,
    packagesActions.searchPackageAction,
    packagesActions.searchPackageHotelsAction,
    packagesActions.searchPackageHotelsWithFiltersAction,
    busesActions.searchBusesAction,
    busesActions.clearBusesResultsAction,
    autosActions.fetchAutoCategoriesResultsAction,
    autosActions.searchAutoAction,
    autosActions.fetchAutoResultsAction,
    hotelsActions.searchHotelsAction,
    hotelsActions.fetchHotelsWithFiltersAction,
    hotelsActions.searchHotelsMarkersAction,
    activitiesActions.fetchActivitiesResultsAction,
    activitiesActions.fetchActivitiesResultsWithFilterAction,
    () => false
  ),
  on(
    globalActions.searchErrorAction,
    flightsActions.fetchAirGroupResultsSuccessAction,
    flightsActions.fetchAirResultsSuccessAction,
    flightsActions.fetchAirResultsBySectorSuccessAction,
    flightsActions.searchFlightsForDesktopErrorAction,
    flightsActions.searchFlightsForMobileErrorAction,
    packagesActions.searchPackageHotelsSuccessAction,
    packagesActions.searchPackageHotelsWithPaginationSuccessAction,
    packagesActions.searchPackageHotelsErrorAction,
    packagesActions.searchPackageHotelsWithFiltersSuccessAction,
    packagesActions.searchPackageFlightsForDesktopSuccessAction,
    packagesActions.searchPackageFlightsForMobileSuccessAction,
    packagesActions.searchPackageFlightsForMobileErrorAction,
    packagesActions.searchPackageFlightsForDesktopErrorAction,
    packagesActions.searchPackageHotelsWithMarkersSuccessAction,
    packagesActions.searchPackageHotelsErrorAction,
    busesActions.searchBusesForDesktopSuccessAction,
    busesActions.searchBusesForMobileSuccessAction,
    busesActions.searchBusesForMobileErrorAction,
    busesActions.searchBusesForDesktopErrorAction,
    busesActions.noResultsSearchBusesAction,
    autosActions.searchAutoErrorAction,
    autosActions.searchAutoCategoriesErrorAction,
    autosActions.fetchAutoCategoriesResultsSuccessAction,
    autosActions.clearAutoResultsAction,
    autosActions.searchAutoSuccessAction,
    autosActions.fetchAutoResultsSuccessAction,
    autosActions.clearAutoCategoriesAction,
    hotelsActions.clearHotelResultsAction,
    hotelsActions.searchHotelsSuccessAction,
    hotelsActions.searchHotelsErrorAction,
    hotelsActions.fetchHotelsWithFiltersSuccessAction,
    hotelsActions.fetchHotelsMarkersWithFiltersSuccessAction,
    activitiesActions.fetchActivitiesResultsSuccessAction,
    activitiesActions.cleanActivitiesResultsAction,
    () => initialState
  ),
  on(packagesActions.searchPackageHotelsWithPaginationAction, (state, { payload }) => payload?.ResultCountLowerBound !== 0),
  on(flightsActions.fetchAirResultsAction, (state, { paginated }) => !!paginated),
  on(
    packagesActions.searchPackageHotelsWithFiltersAction,
    packagesActions.searchPackageFlightsForDesktopAction,
    packagesActions.searchPackageFlightsForMobileAction,
    packagesActions.searchPackageHotelsWithMarkersAction,
    (state, { block }) => !!block
  ),
);

export const isHeaderEditButtonVisibleReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
